const rotatePageRequests = {
  onRotatePageRequest: (data) => ({
    url: 'api/pages/rotate',
    method: 'post',
    data,
  }),
}

export default rotatePageRequests
